module.exports = __webpack_public_path__ + "images/components/estimate_banners/form_with_image/callout_sp_14596a4752b658d968ae2ab841c52087.svg";